<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 12.5V20L26.25 23.75"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 16.25H5V10"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5625 30.0001C12.5281 31.8549 14.9966 33.0892 17.6597 33.549C20.3228 34.0088 23.0624 33.6737 25.5361 32.5854C28.0098 31.4972 30.108 29.7041 31.5684 27.4302C33.0289 25.1563 33.7869 22.5024 33.7477 19.8002C33.7085 17.098 32.8739 14.4672 31.3482 12.2366C29.8224 10.006 27.6731 8.2745 25.1689 7.2584C22.6647 6.24231 19.9166 5.98669 17.2679 6.5235C14.6193 7.06031 12.1875 8.36574 10.2766 10.2767C8.4375 12.1392 6.91875 13.8954 5 16.2501"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ClockCounterIcon",
};
</script>
